import React from "react";
import { Link } from "react-router-dom";
import { InfoCard } from "../../components/info-card.tsx";

export function OwnerLinkInvalid() {
  return (
    <InfoCard
      title="Link invalid"
      description="This sign-in link is unknown, already used, or expired. Request a new one from the sign-in page."
    >
      <Link
        to="/"
        className="font-mono text-xs uppercase tracking-wider no-underline"
      >
        ← Back to sign in
      </Link>
    </InfoCard>
  );
}
